import { IconShoppingCartCheck } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { TimeSeriesChart } from '@charts';

export default function SalesAmountChart({ report, timeSeries, reportLoading, currency = 'BRL' }) {
    const { t } = useTranslation('dashboard');

    return (
        <TimeSeriesChart
            title={t('insights.charts.salesAmountTitle', { currency })}
            icon={<IconShoppingCartCheck size={15} />}
            timeSeries={timeSeries}
            valueType="number"
            unitSingular={t('insights.charts.unitSaleSingular')}
            unitPlural={t('insights.charts.unitSalePlural')}
            report={report}
            reportLoading={reportLoading}
            cornerRadius="large"
        />
    );
}
